export const HiveOrderCodes = { "TransportGetOrder": "GET", "TransportPutOrder": "PUT", "TransportPositionOrder": "POS", "TransportDeleteOrder": "DEL" };
export const UnknownVehicleName = "AGV_VEHICLE";
export const MachineCodes = {"Line21":"EMB21","Line22": "EMB22", "Line23":"EMB23", "Line24": "EMB24", "Line25":"EMB25"};
export const MysoftApplicationID = 11;